 <p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog" *ngIf="error">
    <div class="container">
      <div class="wrapper">
        <div style="text-align: end;">
            <strong *ngIf="error.caseId" style="font-size: 0.8rem; color: #636363;">
              {{error.caseId}}
            </strong>
        </div>
        <div class="dialog__icon">
          <div class="icon__state icon__state--error">
            <div class="embedded-component-svg embedded-component-svg--fill">
              <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
                <path d="M20.3543 42.0348C15.3864 44.9328 12.9714 41.6554 12.3849 39.6544C12.0744 38.2053 11.1778 37.0296 8.5554 36.7564C3.58747 36.2389 3.38048 33.0305 3.69103 30.8571C3.69103 29.6151 4.20851 27.4416 2.55254 25.9926C-1.5874 23.4052 0.172074 19.3687 1.82805 18.0233C3.38053 16.5743 3.89803 14.7113 3.69103 13.0553C2.69744 7.83903 6.17499 6.4659 8.03796 6.43138C9.17645 6.43138 11.7018 5.7483 12.6954 3.016C13.9374 -0.399383 17.4912 -0.469584 19.3193 0.635537C21.6312 2.22138 23.3194 2.2916 24.5977 1.15299C27.1166 -1.09064 31.6058 0.721257 32.2566 2.70546C33.3265 4.80884 34.8441 6.43138 36.5 6.43138C40.7435 6.01739 42.5378 10.0872 41.6749 11.8133C41.1985 12.7664 40.5365 15.2287 42.1924 16.8847C46.2289 19.6792 45.2974 23.8191 43.2274 25.3716C40.9505 27.1311 40.9854 28.4065 41.1575 29.7185C42.7099 33.548 40.226 36.5494 37.328 36.7564C33.9126 36.9634 32.9811 38.7229 32.2566 40.4824C31.4286 43.0698 28.3586 44.0347 26.0816 42.8963C23.5291 41.1702 21.6312 41.3438 20.3543 42.0348Z" fill="#E70F47"/>
                <ellipse cx="21.7352" cy="21.5419" rx="12.4198" ry="12.4198" fill="#EC7F9B"/>
                <path d="M13.4207 15.8155C9.03236 21.6942 11.8292 28.3366 13.6576 30.9585C9.82807 28.1641 7.13714 20.4017 11.7648 14.1595C18.1862 5.49778 29.1823 9.84475 31.0453 13.3637C28.6648 10.9832 18.9061 8.4671 13.4207 15.8155Z" fill="#F25A81"/>
                <path d="M25.4267 15.2634C24.9455 15.2557 24.4729 15.4178 24.0913 15.7215L23.8187 15.9809L16.9238 23.7846L16.6999 24.0871C16.4456 24.5032 16.343 24.9922 16.4099 25.4688C16.4769 25.9453 16.7091 26.3792 17.0662 26.6947C17.4233 27.0102 17.8825 27.1873 18.3637 27.195C18.8449 27.2028 19.3175 27.0406 19.6991 26.737L19.9717 26.4776L26.8666 18.6738L27.0905 18.3714C27.3448 17.9553 27.4475 17.4663 27.3805 16.9897C27.3136 16.5131 27.0813 16.0792 26.7242 15.7637C26.3671 15.4482 25.9079 15.2712 25.4267 15.2634Z" fill="#FFEBF0"/>
                <path d="M17.9738 15.2634C18.455 15.2557 18.9276 15.4178 19.3092 15.7215L19.5818 15.9809L26.4767 23.7846L26.7005 24.0871C26.9549 24.5032 27.0575 24.9922 26.9906 25.4688C26.9236 25.9453 26.6913 26.3792 26.3343 26.6947C25.9772 27.0102 25.518 27.1873 25.0368 27.195C24.5556 27.2028 24.0829 27.0406 23.7014 26.737L23.4288 26.4776L16.5338 18.6738L16.31 18.3714C16.0557 17.9553 15.953 17.4663 16.02 16.9897C16.0869 16.5131 16.3192 16.0792 16.6763 15.7637C17.0334 15.4482 17.4926 15.2712 17.9738 15.2634Z" fill="#FFEBF0"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="dialog__info dialog__info--error">
          <h2 *ngIf="error.title">{{ error.title }}</h2>
          <p *ngIf="error.message">{{ error.message }}</p>
        </div>
        <div class="dialog__text miniPad">
          <div class="errorMsg">
            <p *ngIf="error.optionalMessage">{{ error.optionalMessage }}</p>
          </div>
        </div>
        <div class="dialog__footer" *ngIf="error.button">
          <button *ngIf="error.button.routerLink; else withMethod"
                  pButton pRipple label="{{error.button.label}}"
                  icon="{{error.button.icon ? 'pi pi-angle-' + error.button.iconPos : null}}"
                  [iconPos]="getIconPosition()"
                  class="p-button-primary p-button-raised p-button-rounded p-button-spaced n-border w-full"
                  [routerLink]="[error.button.routerLink]"
                  [queryParams]="error.button.queryParams"
                  (click)="visible=false"></button>
          <ng-template #withMethod>
            <button pButton pRipple
                    label="{{error.button.label}}"
                    icon="{{error.button.icon ? 'pi pi-angle-' + error.button.iconPos : null}}"
                    [iconPos]="getIconPosition()"
                    class="p-button-primary p-button-raised p-button-rounded p-button-spaced n-border w-full"
                    (click)="error.button.method?.(); visible=false"></button>
          </ng-template>
        </div>
        <div class="dialog__footer" *ngIf="!error.button">
          <div class="btn__item pb-15">
            <button pButton pRipple
              label="Volver al inicio"
              icon="pi pi-angle-left"
              iconPos="left"
              class="p-button-secondary p-button-raised p-button-rounded p-button-spaced w-full"
              (click)="goToHome()">
            </button>
          </div>
          <div class="btn__item">
            <button pButton pRipple
              label="Recargar la página"
              icon="pi pi-refresh"
              iconPos="right"
              class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"
              (click)="location.reload()">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
